import { render, staticRenderFns } from "./CompraDividaList.vue?vue&type=template&id=8d6e1012&scoped=true&"
import script from "./CompraDividaList.vue?vue&type=script&lang=js&"
export * from "./CompraDividaList.vue?vue&type=script&lang=js&"
import style0 from "./CompraDividaList.vue?vue&type=style&index=0&id=8d6e1012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6e1012",
  null
  
)

export default component.exports